import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'QUEST_MUTUAL',
  title: 'Il mio cliente non è iscritto, può recuperare la mia cartella?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Lo scopo della piattaforma è quello di consentire di depositare i documenti una sola volta in modo che l\'intera rete possa accedervi. In qualità di socio, l\'utente consente alla propria rete di accedere gratuitamente ai propri documenti anche se non sono presenti su OnceForAll.'
  }]
};
